import "./decomissionPopup.scss";

import { createListComponent, IListComponent, Keys, StaticModelSource } from "~ui-lib";
import { DOMHelper, IPage, View } from "~ui-lib";

import { exitApp } from "../../main";
import { sendPianoAnalytic } from "../../tools/analytics/piano";
import { DecommissionHelper } from "../../tools/decommissionHelper";
import { CardDecommissionView } from "../../views/decomission/cardDecomissionView";

export enum DecommissionButtonType {
  regarder = "Regarder Okoo sur france.tv",
}

export class DecommissionPopup extends View implements IPage {
  listComponent?: IListComponent<DecommissionButtonType>;
  constructor() {
    super(DOMHelper.createDivWithParent(null, "DecommissionPopup"));
    const containerElement = DOMHelper.createDivWithParent(this.rootElement, "DecommissionPopupContainer");
    DOMHelper.createDivWithParent(
      containerElement,
      "DecommissionPopupTitle",
      null,
      "Hé ! L’app TV Okoo est maintenant sur france.tv"
    );

    DOMHelper.createDivWithParent(
      containerElement,
      "DecommissionPopupSubtitle",
      null,
      "Viens retrouver tes dessins animés et tes héros préférés, toujours dans un espace sécurisé et gratuit !"
    );
    this.listComponent = this.delegate = createListComponent({
      rootElement: containerElement,
      modelSource: new StaticModelSource([DecommissionButtonType.regarder]),
      viewFactory: model => new CardDecommissionView(model),
      horizontal: true,
      pageSize: 1,
      visibleBefore: 0,
      visibleAfter: 1,
      onSelect: this.onSelect,
    });
    DOMHelper.createDivWithParent(containerElement, "decomissionLogo", null);
    this.listComponent.setFocusOnId(DecommissionButtonType.regarder);

    DOMHelper.createDivWithParent(containerElement, "DecomissionEllipse", null);
  }
  onSelect = (model: DecommissionButtonType): boolean => {
    switch (model) {
      case DecommissionButtonType.regarder:
        sendPianoAnalytic(
          "click.action",
          {
            feature: "decommissionnement_okoo_tv",
            click: "regarder_okoo_sur_francetv",
          },
          {}
        );
        DecommissionHelper.launchAppFTV();
        return true;
    }
    return false;
  };
  isPopup = () => true;
  onNav = (key: Keys): boolean => {
    switch (key) {
      case Keys.back:
        exitApp();
        return true;
    }
    return false;
  };

  onShown() {
    sendPianoAnalytic(
      "publisher.impression",
      {
        feature: "decommissionnement_okoo_tv",
      },
      {}
    );
  }
}
